import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Box, Button, InputAdornment, TextField, Typography} from "@mui/material";

import {toast} from "react-toastify";

const EditableInput = ({title, icon, placeholder, detail, label, name, noEdit, onSave, onSuccessMessage, loading}) => {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(detail);
  const [error, setError] = useState("");
  const placeholderText = useMemo(() => `Add ${(placeholder || title).toLowerCase()}`, [title, placeholder]);

  useEffect(() => setValue(detail), [detail]);

  const handleEdit = () => setEdit(true);

  const handleSave = useCallback(async () => {
    if (!value) {
      setError("Please enter a value");
      return;
    }
    onSave &&
      onSave({[name || title]: value})
        .then(() => {
          setEdit(false);
          toast.success(onSuccessMessage);
        })
        .catch((err) => {
          setError(err.message);
        });
  }, [name, title, value]);

  const handleCancel = useCallback(() => {
    setEdit(false);
    setValue(detail);
  }, [detail]);

  return (
    <Box className="acDetails !pb-3">
      <Typography
        className="text-white"
        textTransform="uppercase"
        color="rgba(255, 255, 255, 0.6)"
        fontWeight={700}
        fontSize="0.75rem"
        letterSpacing="1.25px"
      >
        <span style={{paddingRight: icon ? "5px" : "none"}}>{icon}</span> {title}
      </Typography>

      <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="space-between">
        {edit ? (
          <TextField
            variant="outlined"
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            error={!!error}
            helperText={error}
            placeholder={placeholderText}
            className="!text-white"
            inputRef={(input) => input && input.focus()}
            sx={{
              ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #EDA044",
              },
              ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #EDA044",
              },
            }}
            InputProps={{
              className: "!text-white",
              endAdornment: (
                <InputAdornment position="end" className="gap-2">
                  {detail != value && (
                    <Button className="btnEdit " onClick={handleSave} disabled={loading}>
                      Save
                    </Button>
                  )}
                  <Button className="btnEdit " onClick={handleCancel}>
                    Cancel
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <>
            <Typography
              id="6"
              sx={{textTransform: "unset !important", color: "rgba(255, 255, 255, 0.87)", letterSpacing: "0.5px"}}
            >
              {value} {value ? label : placeholderText}
            </Typography>
            {!noEdit && (
              <Button className="btnEdit" onClick={handleEdit}>
                {value ? "Edit" : "Add"}
              </Button>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default EditableInput;
